  import * as ActionTypes from "../Types/ActionTypes";

  export const DashboardTwo = (
    state = {
      isLoading: false,
      dashboardTwoState: null,
    },
    action
  ) => {
    switch (action.type) {
      case ActionTypes.DASHBOARD_TWO_LOADER_START:
        return {
          ...state,
          isLoading: true,
        };

      case ActionTypes.DASHBOARD_TWO:
        return {
          ...state,
          isLoading: false,
          dashboardTwoState: action.payload,
        };

      case ActionTypes.DASHBOARD_TWO_LOADER_STOP:
        return {
          ...state,
          isLoading: false,
        };

      default:
        return state;
    }
  };
